module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_300.9c7d8f54.csv";